import React, { useEffect, useState } from 'react';

export default function DropDown({ children, resetKey }) {
  const [mobileToggle, setMobileToggle] = useState(false);

  useEffect(() => {
    setMobileToggle(false);
  }, [resetKey]);

  const handelMobileToggle = () => {
    setMobileToggle((open) => !open);
  };

  return (
    <>
      <span
        className={
          mobileToggle
            ? 'cs_munu_dropdown_toggle active'
            : 'cs_munu_dropdown_toggle'
        }
        onClick={handelMobileToggle}
        aria-hidden="true"
      >
        <span></span>
      </span>
      {children}
    </>
  );
}
